import {Routes, Route, Navigate} from "react-router-dom";
import Private from "./components/Private.js";

import Login from "./components/Account/Login.js";
import ForgotPassword from "./components/Account/ForgotPassword.js";
import ResetPassword from "./components/Account/ResetPassword.js";
import Register from "./components/Account/Register.js";
import Logout from "./components/Account/Logout.js";
import PricesList from './components/Admin/Prices/List.js';
import PricesForm from './components/Admin/Prices/Form.js';
import TagsList from './components/Admin/Tags/List.js';
import TagsForm from './components/Admin/Tags/Form.js';
import DpcActionsList from './components/Admin/Dpc/Actions/List.js';
import DpcActionsForm from './components/Admin/Dpc/Actions/Form.js';
import DpcActionsPlan from './components/Admin/Dpc/Actions/Plan.js';
import DpcSessionsForm from './components/Admin/Dpc/Sessions/Form.js';
import DpcSessionsIndex from './components/Admin/Dpc/Sessions/Index.js';
import DpcInvoicesList from './components/Admin/Dpc/Invoices/List.js';
import DpcRedirectTo from './components/Admin/Dpc/RedirectTo.js';
import DpcRedirectActionSessions from './components/Admin/Dpc/RedirectActionSessions.js';
import DpcRegistrationsList from './components/Admin/Dpc/Registrations/List.js';
import DpcRegistrationsForm from './components/Admin/Dpc/Registrations/Form.js';
import AuditsForm from './components/Admin/Audits/Form.js'; 
import ReviewsList from './components/Marketing/Reviews/List.js';
import CourseList from './components/Admin/Courses/List.js';
import CourseForm from './components/Admin/Courses/Form.js';
import CsvList from './components/Admin/Csv/List.js';
import EmailList from './components/Marketing/Emails/List.js';
import EmailForm from './components/Marketing/Emails/Form.js';
import SocialPosts from './components/Social/Index.js';
import SocialForm from './components/Social/Form.js';
import Study from "./components/Study/Study.js";
import RewardList from './components/Marketing/Rewards/List.js';
import RewardForm from './components/Marketing/Rewards/Form.js';
import Person from './components/Crm/Person/Index.js'
import DpcPiSignature from './components/Dpc/PiSignature.js'
import PersonForm from './components/Crm/Person/Form.js'
import PersonList from './components/Crm/Persons.js'
import HotList from './components/Crm/Hots.js'
import ProspectList from './components/Crm/Prospects.js'
import Prospect from './components/Crm/Prospect/Index.js'
import Activities from './components/Crm/Activities.js'
import EnrollmentList from './components/Crm/Enrollments.js'
import DpcOrphans from './components/Crm/DpcOrphans.js'
import Groups from './components/Crm/Groups.js'
import Firms from './components/Crm/Firms.js'
import GroupForm from './components/Crm/Companies/GroupForm.js'
import FirmForm from './components/Crm/Companies/FirmForm.js'
import Stats from './components/Marketing/Stats/Index.js'
import Orders from './components/Crm/Orders.js'
import Indent from "./components/Shop/Indent/Index.js";
import OrderForm from "./components/Order/Form.js";
import Validate from "./components/Shop/Indent/Validate.js";
import EventActivities from "./components/Crm/EventActivities.js";
import Courses from "./components/Courses/Courses.js";
import Sticker from "./components/Marketing/Sticker/Index.js";
import Profile from "./components/Account/Profile.js";
import DeleteAccount from "./components/Account/Delete.js";
import NotFound from "./components/NotFound.js";
import Signature from "./components/Signature/Page.js";
import TeacherDashboard from "./components/Teacher/Dashboard.js";
import TeacherReviews from "./components/Teacher/Reviews.js";
import CompanyDashboard from "./components/Company/Dashboard.js";
import CompanyEnrollments from "./components/Company/Enrollments.js";
import CompanyContact from "./components/Company/Contact/Index.js";
import CompanyContactForm from "./components/Company/Contact/Form.js";
import Tutos from "./components/Courses/Tutos.js";
import StickerActions from "./components/Marketing/Sticker/Actions.js";
import StickerActionForm from "./components/Marketing/Sticker/ActionForm.js";
import StickerConversions from "./components/Marketing/Sticker/Conversions.js";
import Agreement from "./components/Courses/Agreement.js";
import Signatures from "./components/Crm/Signatures.js";
import Sponsor from "./components/Account/Sponsor.js";
import Affiliate from "./components/Account/Affiliate.js";
import DesignForm from "./components/Manage/CourseForm.js";
import DesignPlan from "./components/Manage/Plan.js";
import DesignSessions from "./components/Manage/Sessions.js";
import CourseOverview from "./components/Manage/CourseOverview.js";
import DesignQuiz from "./components/Manage/Quiz.js";
import DesignAudit from "./components/Manage/Audit.js";
import Order from "./components/Order/Index.js";
import OrderComplete from "./components/Order/Complete.js";
import OrderProduct from "./components/Order/Product.js";
import ProductsList from './components/Admin/Products/List.js';
import ProductsForm from './components/Admin/Products/Form.js';
import Reward from './components/Reward/Form.js';
import Auth from "./components/Account/Auth.js";
import Organize from "./components/Account/Organize.js";
import EventForm from "./components/Manage/EventForm.js";
import EventOverview from "./components/Manage/EventOverview.js";
import Products from "./components/Manage/Products.js";
import EventPlace from "./components/Manage/EventPlace.js";
import Dashboard from "./components/Dashboard/Dashboard.js";
import Certificate from "./components/Manage/Certificate.js";
import Funding from "./components/Apply/Funding.js";
import DpcTuto from "./components/Apply/DpcTuto.js";
import DpcFetch from "./components/Apply/DpcFetch.js";
import DpcSuccess from "./components/Apply/DpcSuccess.js";
import ApplyAuth from "./components/Apply/Auth.js";
import ApplySignIn from "./components/Apply/SignIn.js";
import ApplySignUp from "./components/Apply/SignUp.js";
import Success from "./components/Apply/Success.js";
import Opco from "./components/Apply/Opco.js";
import DpcAdminParticipation from "./components/Dpc/AdminParticipation.js";
import Free from "./components/Apply/Free.js";
import Pack from "./components/Packs/Pack.js";
import Etudiant from "./components/Apply/Etudiant.js";
import DpcPending from "./components/Apply/DpcPending.js";
import Faq from "./components/Dashboard/Faq.js";

export default function Router(){

    return <Routes>
          
        <Route path="/register" element={<Register/>} />
        <Route path="/auth" element={<Auth/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/logout" element={<Logout/>} />
        <Route path="/password/forgot" element={<ForgotPassword/>} />
        <Route path="/password/reset/:key" element={<ResetPassword/>} />
        <Route path="/" element={<Private><Dashboard/></Private>} />
        <Route path="/profile" element={<Private><Profile/></Private>} />
        <Route path="/profile/delete" element={<Private><DeleteAccount/></Private>} />
        <Route path="/sponsor" element={<Private><Sponsor/></Private>} />
        <Route path="/affiliate/:id" element={<Private><Affiliate/></Private>} />
        <Route path="/organize" element={<Private><Organize/></Private>} />
        <Route path="/faq" element={<Faq />} />


        <Route path="/courses/:id/enroll" element={<Funding />} />
        <Route path="/courses/:id/auth" element={<ApplyAuth />} />
        <Route path="/courses/:id/signin" element={<ApplySignIn />} />
        <Route path="/courses/:id/signup" element={<ApplySignUp />} />
        <Route path="/courses/:id/opco" element={<Opco />} />
        <Route path="/courses/:id/etudiant" element={<Etudiant />} />
        <Route path="/courses/:id/free" element={<Free />} />
        <Route path="/courses/:id/dpc/pending" element={<DpcPending />} />
        <Route path="/courses/:id/dpc/:ref" element={<DpcTuto />} />
        <Route path="/courses/:id/dpc/:ref/fetch" element={<DpcFetch />} />
        <Route path="/courses/:id/success" element={<Success />} />
        <Route path="/dpc/success/:id" element={<DpcSuccess />} />
        <Route path="/dpc/success" element={<DpcSuccess />} />


        <Route path="/enrollments" element={<Private><Dashboard/></Private>} />
        <Route path="/courses" element={<Private><Courses/></Private>} />
        <Route path="/tutos" element={<Private><Tutos/></Private>} />
        <Route path="/dpc/participation/:id" element={<Private roles={['admin']}><DpcAdminParticipation/></Private>} />
        <Route path="/dpc/participation/:id/signature" element={<Private><DpcPiSignature/></Private>} />
        <Route path="/agreements/:id" element={<Private><Agreement/></Private>} />
        <Route path="/reward" element={<Private><Reward/></Private>} />
        <Route path="/packs/:reference" element={<Private><Pack /></Private>} />
        
        
        
        <Route path="/teacher" element={<Private roles={['teacher']}><TeacherDashboard/></Private>} />
        <Route path="/teacher/reviews" element={<Private roles={['teacher']}><TeacherReviews/></Private>} />

        <Route path="/company" element={<Private roles={['company']}><CompanyDashboard/></Private>} />
        <Route path="/company/contacts/:id" element={<Private roles={['company']}><CompanyContact/></Private>} />
        <Route path="/company/contacts/:id/edit" element={<Private roles={['company']}><CompanyContactForm/></Private>} />
        <Route path="/company/enrollments" element={<Private roles={['company']}><CompanyEnrollments/></Private>} />


        <Route path="/orders/:uuid" element={<Order />} />
        <Route path="/orders/:uuid/complete" element={<OrderComplete />} />
        <Route path="/products/:id/order" element={<Private><OrderProduct /></Private>} />


        <Route path="/public/indents/:uuid" element={<Indent/>} />
        <Route path="/public/indents/:uuid/validate/:pin" element={<Validate/>} />
        <Route path="/indents/:uuid" element={<Private><Indent/></Private>} />
        <Route path="/indents/:uuid/validate" element={<Private><Validate/></Private>} />


        <Route path="/signatures/:id" element={<Private><Signature /></Private>} />
        

        <Route path="/study/:course" element={<Private><Study/></Private>} />
        <Route path="/study/:course/:tab" element={<Private><Study/></Private>} />
        <Route path="/study/:course/:tab/:option" element={<Private><Study/></Private>} />


        <Route path="/community/posts/:id/edit" element={<Private><SocialForm/></Private>} />
        <Route path="/community/:filter" element={<Private><SocialPosts/></Private>} />
        <Route path="/community/:filter/:id" element={<Private><SocialPosts/></Private>} />


        <Route path="/admin/prices" element={<Private roles={['admin']}><PricesList/></Private>} />
        <Route path="/admin/prices/:id" element={<Private roles={['admin']}><PricesForm/></Private>} />
        <Route path="/admin/tags" element={<Private roles={['admin']}><TagsList/></Private>} />
        <Route path="/admin/tags/:id" element={<Private roles={['admin']}><TagsForm/></Private>} />
        <Route path="/dpc/actions" element={<Private roles={['admin']}><DpcActionsList/></Private>} />
        <Route path="/dpc/actions/:id" element={<Private roles={['admin']}><DpcActionsForm/></Private>} />
        <Route path="/dpc/actions/:id/plan" element={<Private roles={['admin']}><DpcActionsPlan/></Private>} />
        <Route path="/dpc/actions/:actionId/sessions" element={<Private roles={['admin']}><DpcRedirectActionSessions /></Private>} />
        <Route path="/dpc/actions/:actionId/sessions/:id" element={<Private roles={['admin']}><DpcSessionsForm/></Private>} />
        <Route path="/dpc/sessions" element={<Private roles={['admin']}><DpcSessionsIndex/></Private>} />
        <Route path="/dpc/invoices" element={<Private roles={['admin']}><DpcInvoicesList/></Private>} />
        <Route path="/dpc/orphans" element={<Private roles={['admin']}><DpcOrphans/></Private>} />
        <Route path="/dpc/sessions/:id/registrations" element={<Private roles={['admin']}><DpcRegistrationsList/></Private>} />
        <Route path="/dpc/sessions/:sessionId/registrations/:id" element={<Private roles={['admin']}><DpcRegistrationsForm/></Private>} />

        <Route path="/admin/dpc/actions" element={<Navigate to="/dpc/actions" replace />} />
        <Route path="/admin/dpc/actions/:id/plan" element={<Private roles={['admin']}><DpcRedirectTo to="/dpc/actions/:id/plan" /></Private>} />
        <Route path="/admin/dpc/actions/:actionId/sessions" element={<Private roles={['admin']}><DpcRedirectActionSessions /></Private>} />
        <Route path="/admin/dpc/actions/:actionId/sessions/:id" element={<Private roles={['admin']}><DpcRedirectTo to="/dpc/actions/:actionId/sessions/:id" /></Private>} />
        <Route path="/admin/dpc/actions/:id" element={<Private roles={['admin']}><DpcRedirectTo to="/dpc/actions/:id" /></Private>} />
        <Route path="/admin/dpc/sessions/:id/registrations" element={<Private roles={['admin']}><DpcRedirectTo to="/dpc/sessions/:id/registrations" /></Private>} />
        <Route path="/admin/dpc/sessions/:sessionId/registrations/:id" element={<Private roles={['admin']}><DpcRedirectTo to="/dpc/sessions/:sessionId/registrations/:id" /></Private>} />
        <Route path="/admin/courses" element={<Private roles={['admin']}><CourseList/></Private>} />
        <Route path="/admin/courses/:id/audit" element={<Private roles={['admin']}><AuditsForm/></Private>} />
        <Route path="/admin/courses/:id" element={<Private roles={['admin']}><CourseForm/></Private>} />
        <Route path="/admin/csv" element={<Private roles={['admin']}><CsvList/></Private>} />
        <Route path="/admin/products" element={<Private roles={['admin']}><ProductsList/></Private>} />
        <Route path="/admin/products/:id" element={<Private roles={['admin']}><ProductsForm/></Private>} />


        <Route path="/marketing/stats" element={<Private roles={['admin']}><Stats/></Private>} />
        <Route path="/marketing/emails" element={<Private roles={['admin']}><EmailList/></Private>} />
        <Route path="/marketing/emails/:id" element={<Private roles={['admin']}><EmailForm/></Private>} />
        <Route path="/marketing/rewards" element={<Private roles={['admin']}><RewardList/></Private>} />
        <Route path="/marketing/rewards/:id" element={<Private roles={['admin']}><RewardForm/></Private>} />
        <Route path="/marketing/reviews" element={<Private roles={['admin']}><ReviewsList/></Private>} />
        <Route path="/marketing/sticker" element={<Private roles={['admin']}><Sticker/></Private>} />
        <Route path="/marketing/sticker/actions" element={<Private roles={['admin']}><StickerActions/></Private>} />
        <Route path="/marketing/sticker/actions/:id" element={<Private roles={['admin']}><StickerActionForm/></Private>} />
        <Route path="/marketing/sticker/actions/:id/conversions" element={<Private roles={['admin']}><StickerConversions/></Private>} />

        <Route path="/crm/activities" element={<Private roles={['admin']}><Activities/></Private>} />
        <Route path="/crm/persons" element={<Private roles={['admin']}><PersonList/></Private>} />
        <Route path="/crm/persons/:id" element={<Private roles={['admin']}><Person/></Private>} />
        <Route path="/crm/persons/:id/edit" element={<Private roles={['admin']}><PersonForm/></Private>} />
        <Route path="/crm/hots" element={<Private roles={['admin']}><HotList/></Private>} />
        <Route path="/crm/prospects" element={<Private roles={['admin']}><ProspectList/></Private>} />
        <Route path="/crm/prospects/:id" element={<Private roles={['admin']}><Prospect/></Private>} />
        <Route path="/crm/enrollments" element={<Private roles={['admin']}><EnrollmentList/></Private>} />
        <Route path="/crm/orphans" element={<Private roles={['admin']}><DpcOrphans/></Private>} />
        <Route path="/crm/groups" element={<Private roles={['admin']}><Groups/></Private>} />
        <Route path="/crm/firms" element={<Private roles={['admin']}><Firms/></Private>} />
        <Route path="/crm/groups/:id" element={<Private roles={['admin']}><GroupForm/></Private>} />
        <Route path="/crm/firms/:id" element={<Private roles={['admin']}><FirmForm/></Private>} />
        <Route path="/crm/orders" element={<Private roles={['admin']}><Orders/></Private>} />
        <Route path="/crm/orders/new" element={<Private roles={['admin']}><OrderForm/></Private>} />
        <Route path="/crm/event-activities" element={<Private roles={['admin']}><EventActivities/></Private>} />
        <Route path="/crm/signatures" element={<Private roles={['admin']}><Signatures/></Private>} />


        <Route path="/design/:id" element={<Private roles={['admin','creator']}><DesignForm/></Private>} />
        <Route path="/design/:id/plan" element={<Private roles={['admin','creator']}><DesignPlan/></Private>} />
        <Route path="/design/:id/sessions" element={<Private roles={['admin','creator']}><DesignSessions/></Private>} />
        <Route path="/design/:id/overview" element={<Private roles={['admin','creator']}><CourseOverview/></Private>} />
        <Route path="/design/:id/quizzes/:quizId" element={<Private roles={['admin','creator']}><DesignQuiz/></Private>} />
        <Route path="/design/:id/audit" element={<Private roles={['admin']}><DesignAudit/></Private>} />
        <Route path="/design/:id/certificate" element={<Private roles={['admin','creator']}><Certificate/></Private>} />


        <Route path="/organize/:id" element={<Private roles={['admin','organizer']}><EventForm/></Private>} />
        <Route path="/organize/:id/overview" element={<Private roles={['admin','organizer']}><EventOverview/></Private>} />
        <Route path="/organize/:id/place" element={<Private roles={['admin','organizer']}><EventPlace/></Private>} />
        <Route path="/organize/:id/products" element={<Private roles={['admin','organizer']}><Products/></Private>} />

        <Route path="*" element={<NotFound />} />
        
    </Routes>
}